import { Box, styled, Typography } from "@mui/material";
import React, { useEffect, useState } from "react";
import { Space, Table, Tag, Input, Button, Modal, Select, Form } from "antd";
import { ClientApi } from "../../services/ClientApi";
import { useLocation, useNavigate } from "react-router-dom";
import { useAxios } from "../../contexts/AxiosProvider";
import { useSnackbar } from "notistack";
import { DomainApi } from "../../services/DomainApi";
import { format } from "date-fns";
import UtcMinusFour from "../../utils/UtcMinusFour";

const { Search } = Input;

const { Option } = Select;

const layout = {
  labelCol: {
    span: 8,
  },
  wrapperCol: {
    span: 8,
  },
};
const tailLayout = {
  wrapperCol: {
    offset: 8,
    span: 8,
  },
};

const ClientContainer = styled(Box)(({ openDrawer, isDashboard }) => ({
  // position: "relative",
  marginLeft: openDrawer ? 240 : isDashboard ? 0 : 80,
  width: openDrawer
    ? "calc(100% - 255px)"
    : isDashboard
    ? "calc(100% - 5px)"
    : "calc(100% - 85px)",
  // backgroundColor: "#f8f8ff",
  // border: openDrawer ? "2px solid green" : "2px solid blue",
  height: "calc(100vh - 70px)",
  // overflowY: "auto",
}));

const SearchAndFilter = styled(Box)(() => ({
  display: "flex",
  margin: "20px 20px",
  flexDirection: "row",
  justifyContent: "space-between",
}));

const Client = ({ openDrawer, userData, clientData }) => {
  const axios = useAxios();
  const location = useLocation();
  const [form] = Form.useForm();
  const { enqueueSnackbar } = useSnackbar();
  const navigate = useNavigate();
  const [clients, setClients] = useState({
    clientList: [],
    totalClients: 0,
  });
  const [loading, setloading] = useState(false);
  const [selectedDomain, setSelectedDomain] = useState("");
  const [clientName, setClientName] = useState("");
  const [domainData, setDomainData] = useState([]);
  const [status, setStatus] = useState("");

  const [isAddClientModalOpen, setIsAddClientModalOpen] = useState(false);
  const showAddClientModal = () => {
    setIsAddClientModalOpen(true);
  };

  const [pagination, setpagiNation] = useState({ pageSize: 10, pageNo: 1 });

  const handlePagination = (page, pageSize) => {
    setpagiNation({ ...pagination, pageNo: page, pageSize: pageSize });
  };

  const handleCancel = () => {
    setClientName("");
    setSelectedDomain("");
    setDomainData([]);
    setIsAddClientModalOpen(false);
  };

  const RenderEngagementComponent = (record) => {
    navigate(`/dep/engagement/${record.client_id}`, {
      state: {
        ...userData,
      },
    });
  };

  const showDeleteConfirm = (record) => {
    Modal.confirm({
      title: "Are you sure you want to delete this client?",
      content: "This action cannot be undone.",
      okText: "Yes",
      okType: "danger",
      cancelText: "No",
      onOk: () => deleteClient(record),
    });
  };

  const deleteClient = async (record) => {
    try {
      const response = await ClientApi.deleteClient(axios, record.client_id);
      if (response.status === 200) {
        enqueueSnackbar("client Deleted", {
          variant: "success",
          autoHideDuration: 3000,
          anchorOrigin: { vertical: "top", horizontal: "right" },
        });
        fetchAllClients();
      }
    } catch (error) {
      if (error.response?.status === 500) {
        enqueueSnackbar("500 Internal Server Error!", {
          variant: "error",
          autoHideDuration: 3000,
          anchorOrigin: { vertical: "top", horizontal: "right" },
        });
      }
    }
  };

  const formatCreationDate = (dateString) => {
    const date = new Date(dateString);
    if (isNaN(date.getTime())) {
      console.error("Invalid date:", dateString);
      return "Invalid date";
    }
    const utcMinusFour = new UtcMinusFour(date);
    return utcMinusFour.formatUtcMinusFour("yyyy-MM-dd hh:mm a");
  };

  const ClientColumns = [
    {
      title: "Function Name",
      dataIndex: "domain_name",
      key: "domain_name",
    },
    {
      title: "Sub-Function Name",
      dataIndex: "client_name",
      key: "client_name",
      onCell: (record) => {
        return {
          onClick: () => {
            RenderEngagementComponent(record); // Call openDrawer function here or pass any necessary data to Engagement component
          },
        };
      },
      render: (text) => <a>{text}</a>,
    },
    {
      title: "Total Pipelines",
      dataIndex: "engagement_count",
      key: "engagement_count",
    },
    {
      title: "Created By",
      dataIndex: "created_by",
      key: "created_by",
    },
    {
      title: "Creation Date",
      dataIndex: "created_at",
      key: "created_at",
      render: (text, record) => formatCreationDate(record.created_at),
    },
    {
      title: "Status",
      key: "status",
      dataIndex: "status",
      filters: [
        {
          text: "approved",
          value: "approved",
        },
        {
          text: "rejected",
          value: "rejected",
        },
        {
          text: "pending",
          value: "pending",
        },
      ],
      filterMultiple: false,
      onFilter: (value, record) => record.status === value,
      render: (_, { status }) => (
        <>
          <Tag
            color={
              status === "approved"
                ? "green"
                : status === "pending"
                ? "yellow"
                : "red"
            }
            key={status}
          >
            {status}
          </Tag>
        </>
      ),
    },
    // {
    //   title: "Action",
    //   key: "action",
    //   onCell: (record) => {
    //     return {
    //       onClick: () => {
    //         showDeleteConfirm(record);
    //       },
    //     };
    //   },
    //   render: (_, record) => (
    //     <Space size="middle">
    //       <a>Delete</a>
    //     </Space>
    //   ),
    // },
  ];

  const handleTableChange = (pagination, filters) => {
    const currentStatus = filters.status ? filters.status[0] : "";
    setStatus(currentStatus);
    fetchAllClients(pagination.current, pagination.pageSize, currentStatus);
  };

  const fetchAllClients = async (
    pageNo = pagination.pageNo,
    pageSize = pagination.pageSize,
    status = ""
  ) => {
    try {
      setloading(true);
      const data = {
        user_id: location.state.userId,
        domain: clientData.domain_id !== "all-clients",
        domain_id:
          clientData.domain_id !== "all-clients" ? clientData.domain_id : "",
        search: false,
        searchParam: "",
        pageNumber: pageNo,
        pageSize: pageSize,
        status: status,
      };
      const response = await ClientApi.getAllClients(axios, data);
      if (response.status === 200) {
        setClients(response.data);
      }
    } catch (error) {
      if (error.response?.status === 500) {
        enqueueSnackbar("500 Internal Server Error!", {
          variant: "error",
          autoHideDuration: 3000,
          anchorOrigin: { vertical: "top", horizontal: "right" },
        });
      }
    } finally {
      setloading(false);
    }
  };
  useEffect(() => {
    fetchAllClients(pagination.pageNumber, pagination.pageSize, status);
  }, [status]);

  const fetchAllDomains = async () => {
    try {
      setloading(true);
      const data = {
        user_id: location.state.userId,
        search: false,
        domainSearchParam: "",
        pageNumber: 0,
        pageSize: 0,
      };
      const response = await DomainApi.getAllDomains(axios, data);
      if (response.status === 200) {
        setDomainData(response.data);
      }
    } catch (error) {
      if (error.response?.status === 500) {
        enqueueSnackbar("500 Internal Server Error!", {
          variant: "error",
          autoHideDuration: 3000,
          anchorOrigin: { vertical: "top", horizontal: "right" },
        });
      }
    } finally {
      setloading(false);
    }
  };
  useEffect(() => {
    if (isAddClientModalOpen) fetchAllDomains();
  }, [isAddClientModalOpen]);

  const handleAddClient = async () => {
    const alphanumericWithLetter = /^(?=.*[a-zA-Z])[a-zA-Z0-9_ ]+$/;
    if (!alphanumericWithLetter.test(clientName)) {
      enqueueSnackbar("Sub-Function should contain letters!!", {
        variant: "error",
        autoHideDuration: 3000,
        anchorOrigin: { vertical: "top", horizontal: "right" },
      });
      return;
    }
    try {
      // Validate if selectedDomain and clientName are not empty
      if (!selectedDomain || !clientName) {
        // Show error message or perform validation logic
        return;
      }
      // Call the API to create the client
      await ClientApi.createClient(
        axios,
        userData.userId,
        userData.username,
        selectedDomain,
        clientName
      );
      // Show success message
      enqueueSnackbar("Sub-Function Created Successfully", {
        variant: "success",
        autoHideDuration: 3000,
        anchorOrigin: { vertical: "top", horizontal: "right" },
      });

      setClientName("");
      setSelectedDomain("");
      setDomainData([]);

      // Fetch all clients again to update the list
      fetchAllClients();
      onReset();
      // Close the modal
      setIsAddClientModalOpen(false);
    } catch (error) {
      if (error.response?.status === 409) {
        enqueueSnackbar("Sub-Function Already Exits in this domain!!", {
          variant: "error",
          autoHideDuration: 3000,
          anchorOrigin: { vertical: "top", horizontal: "right" },
        });
      } else {
        // Show error message
        enqueueSnackbar("Failed to create Sub-Function", {
          variant: "error",
          autoHideDuration: 3000,
          anchorOrigin: { vertical: "top", horizontal: "right" },
        });
      }
    }
  };

  const onSearch = async (value, _e, info) => {
    try {
      setloading(true);
      const data = {
        user_id: location.state.userId,
        domain: clientData.domain_id !== "all-clients",
        domain_id:
          clientData.domain_id !== "all-clients" ? clientData.domain_id : "",
        search: true,
        searchParam: value,
        pageNumber: 0,
        pageSize: 0,
      };
      const response = await ClientApi.getAllClients(axios, data);
      if (response.status === 200) {
        setClients(response.data);
      }
    } catch (error) {
      if (error.response?.status === 500) {
        enqueueSnackbar("500 Internal Server Error!", {
          variant: "error",
          autoHideDuration: 3000,
          anchorOrigin: { vertical: "top", horizontal: "right" },
        });
      }
    } finally {
      setloading(false);
    }
  };

  const onReset = () => {
    form.resetFields();
  };

  return (
    <ClientContainer openDrawer={openDrawer} isDashboard={clientData.dashboard}>
      {clientData.isSearchFilterVisible && (
        <SearchAndFilter>
          <Search
            placeholder="Search Sub-Function"
            allowClear
            enterButton
            size="large"
            onSearch={onSearch}
            style={{ width: "20%" }}
          />
          {/* {clients.clientList.length === 0 && (
            <Button type="primary" size="large" onClick={showAddClientModal}>
              Add Client
            </Button>
          )} */}
          <Button type="primary" size="large" onClick={showAddClientModal}>
            Add Sub-Function
          </Button>
        </SearchAndFilter>
      )}
      <div
        style={{
          width: "100%",
          maxHeight: "85%",
          overflowY: "auto",
        }}
      >
        <Table
          bordered
          loading={loading}
          columns={ClientColumns}
          style={{ fontWeight: "640", margin: "20px 20px" }}
          sticky
          dataSource={clients.clientList}
          pagination={{
            // defaultCurrent: 1,
            // pageSize: pagination.pageSize,
            // total: clients.totalClients,
            // onChange: handlePagination,
            total: clients.totalClients,
            pageSize: pagination.pageSize,
            current: pagination.pageNo,
            onChange: handlePagination,
          }}
          onChange={handleTableChange}
        />
      </div>
      <Modal
        title="Add Sub-Function"
        visible={isAddClientModalOpen}
        onCancel={handleCancel}
        footer={null}
      >
        <Form
          {...layout}
          form={form}
          name="control-hooks"
          onFinish={handleAddClient}
          style={{
            maxWidth: 600,
          }}
        >
          <Form.Item
            name="domain"
            label="Select Function"
            rules={[
              {
                required: true,
              },
            ]}
          >
            <Select
              style={{ width: 200 }}
              onChange={(value) => setSelectedDomain(value)}
              value={selectedDomain}
            >
              {domainData.domainList?.map((item) => {
                if (item.status === "approved") {
                  return (
                    <Option key={item.domain_id} value={item.domain_id}>
                      {item.domain_name}
                    </Option>
                  );
                }
              })}
            </Select>
          </Form.Item>
          <Form.Item
            name="client"
            label="Sub-Function"
            rules={[
              {
                required: true,
              },
            ]}
          >
            <Input
              placeholder="Sub-Function Name"
              value={clientName}
              onChange={(e) => setClientName(e.target.value)}
            />
          </Form.Item>
          <Form.Item {...tailLayout}>
            <Space>
              <Button type="primary" htmlType="submit">
                Submit
              </Button>
              <Button htmlType="button" onClick={onReset}>
                Reset
              </Button>
            </Space>
          </Form.Item>
        </Form>
      </Modal>
    </ClientContainer>
  );
};

export default Client;
